import React from 'react';
import { FieldMessage } from '@kaizen/draft-form';

type Props = {
  id: string;
  uiText: {
    message: string;
  };
};

const ValidationError = (props: Props): React$Element<string> => {
  return (
    <FieldMessage id={props.id} status="error" message={props.uiText.message} />
  );
};

export default ValidationError;
